import { Component } from 'react'
import { Row, Typography } from 'antd'
import IconNoData from '../../icon/icon-no-data-found.png'

const { Text } = Typography

interface Props {
  title: string
  text?: string
  fullheight?: boolean
  tableHeight?: number
  filterApplied?: number
}

export class NotFound extends Component<Props> {
  getNotFoundHeight = () => {
    const { tableHeight, filterApplied } = this.props
    if(tableHeight) return tableHeight
    else {
      const { innerHeight: height } = window
      let h = height - 191 //250
      if (filterApplied && filterApplied > 0) {
        const box = document.getElementById('box-filters-selected')
        if(box && box !== null && box.offsetHeight) {
          console.log(box.offsetHeight)
          h -= box.offsetHeight + 20
        } else {
          h -= 65
        }      
      }
      return h
    }
  }

  render() {
    const { title, text, fullheight } = this.props
    return (
      <Row className="stw-not-found" style={{ height: fullheight ? this.getNotFoundHeight() : 'initial' }}>
        <div className="icona" style={{ backgroundImage: `url(${IconNoData})` }} />
        <Text className="stw-not-found-title" strong>
          {title}
        </Text>
        {text && <Text>{text}</Text>}
      </Row>
    )
  }
}
